export default __webpack_public_path__ + "images/0x6659a9c5cd313974343e30b4fdffd95bd4b4dcd2.png";